/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useState, useEffect } from 'react';
import {
  FormContext,
  FormContextProvider,
  FormSchemaFields,
} from '@sw-sw/lib-form';
import { toInteger, transform } from 'lodash';
import AppContext from '../../../contexts/AppContext';
import { ProjectContext } from '../../../contexts/ProjectContext';
import TenantFeatureContext from '../../../contexts/TenantContext';
import clientApi from '../../../utils/api/client';
import divisionApi from '../../../utils/api/division';
import projectApi from '../../../utils/api/project';
import { UIControlType } from '@sw-sw/lib-form-control-types';
import {
  getDocumentType,
  getPrecipitationFields,
  getProjectInformationSchemaLeft,
  getProjectInformationSchemaRight,
  getSchemaInspectionCertification,
  getSchemaPDFEditing
} from '../Forms/projectFormSchema';
import DashboardContext from '../../../contexts/DashboardContext';
import { RolesContext } from '../../../contexts/RolesContext';
import { extractInitialData } from '../Forms/projectFormData';
import { TooltipContextProvider } from '@sw-sw/lib-ui';
import Loading from '../../Shared/ResourceIndex/Loading';
import { AppDivisionContext } from '../../../contexts/AppDivisionContext';
import { useDivisionClients } from '../../../hooks/client';
import { useCountries, useStates } from '../../../hooks/address';
import uploadApi from '../../../utils/api/upload';
import rolesApi from '../../../utils/api/roles';
import momentTz from 'moment-timezone';
import { env } from '../../../config';
import { ActionButtonsWithScrollFix } from '../../Shared/ActionButtons';
import { submitHandler } from '../../Shared/form';
import { toast } from 'react-toastify';
import userApi from '../../../utils/api/user';
import InspectionSettings from './InspectionSettings';
import tenantApi from '../../../utils/api/tenant';
import NotificationsProjectSetting from './NotificationsProjectSetting/NotificationsProjectSetting';

function ProjectFormUI({
  schemaData,
  handleSubmit,
  disableClient,
  appDivisionId,
  projectId,
  doc_type_group_id,
  existingClientData,
  ...props
}) {
  const [projectInformationCollapse, setProjectInformationCollapse] =
    useState(false);
  const [documentTypesCollapse, setDocumentTypesCollapse] = useState(false);
  const [pdfEditingCollapse, setPdfEditingCollapse] = useState(false);
  const [precipitationCollapse, setPrecipitationCollapse] = useState(false);
  const [inspectionCollapse, setInspectionCollapse] = useState(false);
    const formContext = useContext(FormContext);
  const appContext = useContext(AppContext);
  const projectContext = useContext(ProjectContext);
  const featureContext = useContext(TenantFeatureContext);
  const [clientBasedDocTypes, setClientBasedDocTypes] = useState([]);
  const [docTypeGroups, setDocTypeGroups] = useState([]);
  const [divisionInspectionIntervals, setDivisionInspectionIntervals] =
    useState([]);
  const [inspectionList, setInspectionList] = useState([]);
  const permCheck = useContext(RolesContext).userHasPermission;
  const [notificationCollapse, setNotificationCollapse] = useState(true);
  const [notificationsPayload, setNotificationsPayload] = useState();

  function submit() {
    const { docTypes = {}, routine_interval, primary_contact, ...values } = formContext.value;

    const getSelectedClientDocType= props.clientCheckedDocTypes.find(ele=>ele.id===Number(formContext.value.project_document_group));

    const allClientCheckedDocTypeIds = getSelectedClientDocType.client_group_items.map(
      (ele) => ele.doc_type.id,
    );

    const relevantDoctypes = Object.keys(docTypes)
      .filter((key) => allClientCheckedDocTypeIds.includes(Number(key)))
      .reduce((obj, key) => {
        return Object.assign(obj, {
          [key]: docTypes[key],
        });
      }, {});

    values.client &&
      values.client.map((ele) => {
        delete ele.users;

        return ele;
      });

    // Transform primary_contact from array format to string
    let transformedPrimaryContact = primary_contact;
    if (primary_contact && Array.isArray(primary_contact) && primary_contact.length > 0) {
      transformedPrimaryContact = primary_contact[0].name;
    }
    return handleSubmit({
      ...values,
      primary_contact: transformedPrimaryContact,
      routine_interval: Number(routine_interval),
      doc_type_group_id: Number(formContext.value.project_document_group),
      docTypes: transform(
        relevantDoctypes,
        (acc, val, key) => {
          if (val) acc.push(toInteger(key));
        },
        [],
      ),
    });
  }

  const formData = formContext.value;
  const formSectionProps = {
    formData,
    onChange: formContext.set,
  };
  const clientData =
    formData.client && formData.client.length > 0 ? formData.client[0] : false;

  useEffect(() => {
    async function fetchInspectionTemplates() {
      if (!formContext.value.clientId) {
        setClientBasedDocTypes(schemaData.docTypes);
      } else {

        const docTypeGroupsArr = await clientApi.documentGroups.index(
          formContext.value.clientId,
        );

        setDocTypeGroups(docTypeGroupsArr);

       

        if(doc_type_group_id){
          const selectedGroup = docTypeGroupsArr.find(group => group.id === doc_type_group_id);

          if(selectedGroup){

            const doc_types = selectedGroup.client_group_items

             const filteredClientDocType = doc_types.filter(
          (e) =>
            e.doc_type.name !== 'Fixed Details Project' &&
            e.doc_type.name !== 'Fixed Details' &&
            e.doc_type.name !== 'Active Site Maps' &&
            e.is_checked,
        );

            setClientBasedDocTypes(
              filteredClientDocType.map((docTypeItem) => {
                return docTypeItem.doc_type;
              }),
            );
            
             if(props.checkedDocs){
            formContext.set('docTypes', props.checkedDocs
              .map((doc) => doc.id)
              .reduce((obj, key) => {
                return Object.assign(obj, {
                  [key]: true,
                });
              }, {}),); 
            }

          }       
        }
      }
    }

    fetchInspectionTemplates();

    props.getSelectedValue(formContext.value.clientId);
  }, [formContext.value.clientId,props.checkedDocs]);

 useEffect(() => {

  async function fetchClientDoctypes(){

    if (formContext.value.project_document_group && formContext.value.clientId) {

      const docTypeGroupsArr = await clientApi.documentGroups.index(
          formContext.value.clientId,
        );

          const selectedGroup = docTypeGroupsArr.find(group => group.id === Number.parseInt(formContext.value.project_document_group));

          if(selectedGroup){

            const doc_types = selectedGroup.client_group_items


             const filteredClientDocType = doc_types.filter(
          (e) =>
            e.doc_type.name !== 'Fixed Details Project' &&
            e.doc_type.name !== 'Fixed Details' &&
            e.doc_type.name !== 'Active Site Maps' &&
            e.is_checked,
        );

            setClientBasedDocTypes(
              filteredClientDocType.map((docTypeItem) => {
                return docTypeItem.doc_type;
              }),
            );

           if(props.checkedDocs){
            formContext.set('docTypes', props.checkedDocs
              .map((doc) => doc.id)
              .reduce((obj, key) => {
                return Object.assign(obj, {
                  [key]: true,
                });
              }, {}),); 
            }
          }       
        

      }


  }

        fetchClientDoctypes()

 }, [formContext.value.project_document_group, formContext.value.clientId, props.checkedDocs]);

  useEffect(() => {
    const fetchIntervalsAndUpdateIntervalId = async () => {
      let data = await divisionApi.inspectionIntervals.fetchWithDefaultTrue(
        appDivisionId,
      );

      if (data.length !== 1) {
        data = data.filter((ele) => ele.default === false);
      }

      if (data.length === 1 && projectId) {
        let defaultIntervalId = data[0].id;

        let currentIntervalId = projectContext.project.inspection_interval_id;

        if (defaultIntervalId !== currentIntervalId) {
          await projectApi.updateInspectionIntervalId(
            projectId,
            defaultIntervalId,
          );
        }
      }

      setDivisionInspectionIntervals(data);
    };

    fetchIntervalsAndUpdateIntervalId();
  }, [appDivisionId]);

  useEffect(() => {
    if (!String(formContext.value.longitude).split('').includes('.')) {
      if (!isNaN(formContext.value.longitude)) {
        formContext.set(
          'longitude',
          '-' + Math.abs(formContext.value.longitude).toString(),
        );
      }
      if (formContext.value.longitude === '') {
        formContext.set('longitude', '');
      }
    }
  }, [formContext.value.longitude]);

  return (
    <div   style={{
          marginBottom: '10rem',
        }}
        >
      <section
        className='project-form'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <section className='container create-project-label'>
          <label>Update Project</label>
        </section>
        <ActionButtonsWithScrollFix
          primary='Save'
          spacer={false}
          onClick={(e) => submitHandler(formContext, e, submit)}
        />
      </section>
      <section
        className='project-form'
        style={{ marginTop: '1rem', width: '6rem' }}
      >
        <section className='container'>
          <FormSchemaFields
            {...formSectionProps}
            schema={{
              external_project: {
                label: 'EVP: ',
                controlType: UIControlType.toggleButton,
                toggleSize: 'sm',
                style: {
                  display: featureContext.tenantHasFeature(
                    'External Verification Projects',
                  )
                    ? 'flex'
                    : 'none',
                },
                disabled:projectContext.isDownloaded()
              },
            }}
          />
        </section>
      </section>

      <div id='projectInformation'>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingLeft: '0.5rem',
            paddingRight: '0.5rem',
            cursor: 'pointer',
          }}
          onClick={() =>
            setProjectInformationCollapse(!projectInformationCollapse)
          }
        >
          <h3>Project Information</h3>
          <i
            className={
              projectInformationCollapse
                ? 'fa fa-chevron-down'
                : 'fa fa-chevron-up'
            }
            aria-hidden='true'
          />
        </div>
        <hr></hr>
        {projectInformationCollapse && (
          <section
            className='project-form'
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <section className='container'>
              <FormSchemaFields
                {...formSectionProps}
                schema={getProjectInformationSchemaLeft(
                  schemaData.clients,
                  schemaData.inspectionTemplates,
                  schemaData.states,
                  schemaData.tz,
                  disableClient,
                  formData.inspectionTemplateId,
                  formData.inspection_compliance_required,
                  appContext.get('constants.optionalComplianceTemplates'),
                  appContext.get('constants.ccrTemplates'),
                  formData.external_project,
                  formData.clientId,
                  featureContext.tenantHasFeature('Enable Enhanced Findings'),
                  featureContext.tenantHasFeature('Enable Photo Metadata Requirement') && permCheck('create', 'Enable Photo Metadata'),
                  featureContext.tenantHasFeature('NOAA Weather Table'),
                  featureContext.tenantHasFeature('Guest Sign-Offs') && existingClientData && existingClientData.guest_sign_offs,
                  featureContext.tenantHasFeature('CA - Inspection Scheduler'),
                  existingClientData && existingClientData.ca_inspection_scheduler,
                  existingClientData && existingClientData.forecast_weather,
                  formContext.value.forecast_weather,
                  schemaData.areas,
                  true
                )}
              />
            </section>
            <section className='container'>
              <FormSchemaFields
                {...formSectionProps}
                schema={getProjectInformationSchemaRight(
                  schemaData.users,
                  schemaData.primaryContactUsers,
                  schemaData.projectTypes,
                  divisionInspectionIntervals,
                  schemaData.docGroups,
                  true
                )}
              />
            </section>
          </section>
        )}
      </div>

      <InspectionSettings projectId={projectId} />

      <div id='documentTypes'>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingLeft: '0.5rem',
            paddingRight: '0.5rem',
            cursor: 'pointer',
          }}
          onClick={() => setDocumentTypesCollapse(!documentTypesCollapse)}
        >
          <h3>Document Type</h3>
          <i
            className={
              documentTypesCollapse ? 'fa fa-chevron-down' : 'fa fa-chevron-up'
            }
            aria-hidden='true'
          />
        </div>
        <hr></hr>
        {documentTypesCollapse && (
          <section className='project-form'>
            <section className='container'>
              <FormSchemaFields
                {...formSectionProps}
                schema={getDocumentType(clientBasedDocTypes,docTypeGroups,existingClientData.locked_doc_type_group_id)}
              />
            </section>
          </section>
        )}
      </div>

      <div id='pdfediting'>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingLeft: '0.5rem',
            paddingRight: '0.5rem',
            cursor: 'pointer',
          }}
          onClick={() => setPdfEditingCollapse(!pdfEditingCollapse)}
        >
          <h3>PDF Editing</h3>
          <i
            className={
              pdfEditingCollapse ? 'fa fa-chevron-down' : 'fa fa-chevron-up'
            }
            aria-hidden='true'
          />
        </div>
        <hr></hr>
        {pdfEditingCollapse && (
          <section className='project-form'>
            <section className='container'>
            {props.pdfEditingStatus === 'disabled' && (
              <section className='col-danger'>
                <p>This setting is disabled at Client.”</p>
              </section>
            )}
            {props.pdfEditingStatus === 'locked' && (
              <section className='col-danger'>
                <p>This setting is locked at Client.</p>
              </section>
            )}
            {props.pdfEditingStatus === 'enabled' && (
              <FormSchemaFields
              {...formSectionProps}
              schema={getSchemaPDFEditing()}
            />
            )}
            </section>
          </section>
        )}
      </div>

      <div id='precipitation'>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingLeft: '0.5rem',
            paddingRight: '0.5rem',
            cursor: 'pointer',
          }}
          onClick={() => setPrecipitationCollapse(!precipitationCollapse)}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Precipitation</h3>
            <FormSchemaFields
              {...formSectionProps}
              schema={{
                precipitation_flag: {
                  controlType: UIControlType.toggleButton,
                  checked: false,
                  toggleSize: 'sm',
                  style: {
                    marginTop: '10px',
                    marginLeft: '40px',
                  },
                  disabled:
                    schemaData.precipitation_edit_lock ||
                    !featureContext.tenantHasFeature(
                      'Precipitation Tracking',
                    ) ||
                    (clientData &&
                      !clientData.precipitation_client_project_flag),
                },
              }}
            />
          </div>
          <i
            className={
              precipitationCollapse ? 'fa fa-chevron-down' : 'fa fa-chevron-up'
            }
            aria-hidden='true'
          />
        </div>
        <hr></hr>
        {precipitationCollapse && (
          <>
            <section className='project-form'>
              <section className='container'>
                <FormSchemaFields
                  {...formSectionProps}
                  schema={getPrecipitationFields(
                    formData.precipitation_edit_lock,
                    clientData,
                    featureContext.tenantHasFeature('Precipitation Tracking'),
                    featureContext.tenantHasFeature('Enable Tempest'),
                    formData.weather_station_type === 'tempest'
                  )}
                />
              </section>
            </section>

            {(!featureContext.tenantHasFeature('Precipitation Tracking') ||
              (clientData &&
                !clientData.precipitation_client_project_flag)) && (
              <section className='container precipitation-error-msg-wrapper'>
                <p>
                  “Precipitation Tracking has been turned off, to access please
                  contact your company's administrator.”
                </p>
              </section>
            )}
          </>
        )}
      </div>

      {props.showInspectionCertTimeline && (
        <div id='inspection'>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingLeft: '0.5rem',
              paddingRight: '0.5rem',
              cursor: 'pointer',
            }}
            onClick={() => setInspectionCollapse(!inspectionCollapse)}
          >
            <h3>Inspection</h3>
            <i
              className={
                inspectionCollapse ? 'fa fa-chevron-down' : 'fa fa-chevron-up'
              }
              aria-hidden='true'
            />
          </div>
          <hr></hr>
          {inspectionCollapse && (
            <section className='project-form'>
              <section className='container'>
                <FormSchemaFields
                  {...formSectionProps}
                  schema={{
                    is_inspection_certification_timeline_enabled: {
                      label: 'Enable Inspection Certification Timeline',
                      controlType: UIControlType.checkbox,
                    },
                  }}
                />
                <FormSchemaFields
                  {...formSectionProps}
                  schema={getSchemaInspectionCertification(
                    formContext.value
                      .is_inspection_certification_timeline_enabled,
                    formContext.value.sameForBoth,
                    formContext.value.certification_type || '',
                  )}
                  className='findings-form'
                />
              </section>
            </section>
          )}
        </div>
      )}

      <NotificationsProjectSetting projectId={projectId} onChange={setNotificationsPayload}/>

    </div>
  );
}

function ProjectForm({ initialData, ...props }) {
  const appContext = useContext(AppContext);
  const { appDivisionId } = useContext(AppDivisionContext);
  const projectContext = useContext(ProjectContext);

  // form data
  const clientsQuery = useDivisionClients(appDivisionId);
  const statesQuery =
    env.REACT_APP_REGION === 'UK' ? useCountries() : useStates();
  // const [docTypes, setDocTypes] = useState([]);
  const [docGroups, setDocGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [primaryContactUsers, setPrimaryContactUsers] = useState([]);

  const [tz] = useState(appContext.get('constants.tz'));
  const user = appContext.get('user');
  const [inspectionTemplates, setTemplates] = useState([]);
  const [areas, setAreas] = useState([]);

  // form states
  const [loaded, setLoadedState] = useState(false);
  const [clientId, setClientId] = useState();
  const [checkedDocs, setCheckedDocs] = useState(null);
  const [clientCheckedDocTypes, setclientCheckedDocTypes] = useState();
  //const [defaultChecked, setDefaultChecked] = useState({});
  const [projectTypes, setProjectTypes] = useState();

  function getSelectedValue(value) {
    setClientId(value);
  }

  const projectId = projectContext.project && projectContext.project.id;

  async function fetchClientDocTypes(projectDocsFromContext) {
    if (projectContext.project) {
        // Use projectDocs from context if available, otherwise fetch
      const projectDocs = projectDocsFromContext || await projectApi.getDocs(projectId); //fetching current doctypes addes to Project_doc_types

        const clientDocTypesChecked = await clientApi.documentGroups.index(
          clientId || projectContext.project.client_id,
        );

        setclientCheckedDocTypes(clientDocTypesChecked);

        const selectedGroup = clientDocTypesChecked.find(group => group.id === Number.parseInt(projectContext.project.doc_type_group_id));


            const doc_types = selectedGroup.client_group_items.filter(item=> item.is_checked );

            const clientDocTypes =
              doc_types.map((docTypeItem) => {
                return docTypeItem.doc_type;
              })
            
              

        // fetching all checked form Client_doc_types
        const allClientDocTypeIds = clientDocTypes.map((ele) => ele.id);


        const clientFilteredDocs = projectDocs.documentTypes.filter((ele) =>
          allClientDocTypeIds.includes(ele.id),
        ); //Project_doc_types - Client_doc_types

        setCheckedDocs(clientFilteredDocs);

      } else if (clientId) {
        const clientDocTypes = await clientApi.getClientsDocTypes.forProjects(
          clientId,
        ); // fetching all checked form Client_doc_types
        
        setclientCheckedDocTypes(clientDocTypes);
        setCheckedDocs(clientDocTypes);
      }
    }

  // Track if initial fetch has been done
  const [initialFetchDone, setInitialFetchDone] = useState(false);

  // Initial fetch - use projectDocs from context if available
  useEffect(() => {
    if (!initialFetchDone && projectContext.project) {
      fetchClientDocTypes(projectContext.projectDocs);
      setInitialFetchDone(true);
    }
  }, [projectContext.project, projectContext.projectDocs]);

  // Fetch when clientId changes (user selects different client)
  useEffect(() => {
    if (initialFetchDone && clientId) {
      fetchClientDocTypes(null); // Force fresh fetch when client changes
    }
  }, [clientId]);

  useEffect(() => {
    tenantApi.pdfEditting.getAppendOnlyEnabled(user.tenantId).then(
      (appendOnlyRes) => {
        if (props.pdfEditingStatus === 'enabled') {
          if (!appendOnlyRes.append_only_enabled) {
            props.setPdfEditingStatus('disabled');
          } else if (appendOnlyRes.lock_append_only) {
            props.setPdfEditingStatus('locked');
          } else {
            props.setPdfEditingStatus('enabled');
          }
        }
      }
    )
  }, [props.pdfEditingStatus]);  

  useEffect(() => {
    Promise.all([
      divisionApi.regulations.index(appDivisionId),
      divisionApi.inspectionTemplates.index(appDivisionId),
      rolesApi.inspectorRole(appDivisionId),
      rolesApi.primaryContactRole(projectId),
      projectApi.getProjectTypes(),
      projectApi.get(projectId),
      userApi.tenantInfoInspection(),
      divisionApi.areas.getAll(appDivisionId),
    ])
      .then(
        ([
          docGroupsRes,
          inspTemplRes,
          usersRes,
          primaryContactUsersRes,
          projTypes,
          proj,
          tenantInspectionTimeline,
          areaRes,
        ]) => {
          setDocGroups(docGroupsRes);
          setTemplates(inspTemplRes);
          setAreas(areaRes);
          setUsers(usersRes.data.map((user) => user.user));
          setPrimaryContactUsers(
            primaryContactUsersRes.data.map((user) => user.user),
          );
          setProjectTypes(projTypes);
          projectContext.setProject(proj);
          props.setShowInspectionCertTimeline(
            tenantInspectionTimeline?.getInspectionCertTimeline?.is_inspection_certification_timeline_enabled
            && !tenantInspectionTimeline?.getInspectionCertTimeline?.is_locked
          )
          if (
            initialData &&
            initialData.template &&
            inspectionTemplates.filter(
              ({ id }) => id === initialData.template.id,
            ).length === 0
          ) {
            setTemplates([initialData.template, ...inspectionTemplates]);
          }

          setLoadedState(true);
        },
      )
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.log('Error: mounting', e);
      });
  }, []);

  if (!loaded || clientsQuery.isLoading || statesQuery.isLoading) {
    return <Loading />;
  }

  const timezone = momentTz.tz.guess(true);

  return (
    <FormContextProvider
      initialValue={{
        ...initialData,
        clientId: clientId ? clientId : initialData.clientId,
        project_document_group: initialData.doc_type_group_id
          ? initialData.doc_type_group_id
          : null,
        // docTypes,
        timezone:
          env.REACT_APP_REGION === 'UK'
            ? 'GMT'
            : initialData.timezone && tz.includes(initialData.timezone)
            ? initialData.timezone
            : tz.includes(timezone)
            ? timezone
            : tz[0],
      }}
    >
      <TooltipContextProvider>
        <ProjectFormUI
          {...props}
          schemaData={{
            // docTypes,
            states: statesQuery.data,
            clients: clientsQuery.data,
            docGroups,
            inspectionTemplates,
            users,
            primaryContactUsers,
            projectTypes,
            tz,
            areas
          }}
          getSelectedValue={getSelectedValue}
          clientCheckedDocTypes={clientCheckedDocTypes}
          checkedDocs={checkedDocs}
          doc_type_group_id={initialData.doc_type_group_id}
          appDivisionId={appDivisionId}
          projectId={projectId}
          existingClientData={(initialData.client && initialData.client.length)? initialData.client[0] : null}
        />
      </TooltipContextProvider>
    </FormContextProvider>
  );
}

const ProjectSettings = () => {
  const [client, setClient] = useState();
  const projectContext = useContext(ProjectContext);
  const { getTeamManagementData, fetchStatsFuncForID } =
    useContext(DashboardContext);
  const appContext = useContext(AppContext);
  const [showInspectionCertTimeline, setShowInspectionCertTimeline] =
    useState(false);
  const [pdfEditingStatus, setPdfEditingStatus] = useState('disabled');

  const { project, inspections } = projectContext;

  useEffect(() => {
    appContext.loadData(
      () =>
        clientApi.index([project.client_id]).then((c) => {
          projectContext.setDocumentDate(c[0].document_date);
          setClient(c);
          setShowInspectionCertTimeline(
            c[0].is_inspection_certification_timeline_enabled && 
            !c[0].is_inspection_certification_timeline_locked
          )
          if (!c[0].append_only_enabled) setPdfEditingStatus('disabled');
          else if (c[0].lock_append_only) setPdfEditingStatus('locked');
          else setPdfEditingStatus('enabled');
        }),
      'project details',
    );
  }, []);

  const updateProject = (proj) => {
    projectContext.setProject({
      ...project,
      ...proj,
    });
    projectContext.loadDocs(proj.id);
    projectContext.inspectionsQuery.refetch();
  };

  async function handleEdit(formData) {
    const toastId = toast('Updating project...');
    let no_of_days_acknowledgment = formData.sameForBoth ? formData.no_of_days_compliance : formData.no_of_days_acknowledgment;

    projectApi
      .update(project.id, {
        ...formData,
        no_of_days_acknowledgment: no_of_days_acknowledgment,
      })
      .then((data) => {
        updateProject(data);
        getTeamManagementData.refetch();
        fetchStatsFuncForID.refetch();
        toast.update(toastId, {
          render: 'Project updated successfully',
          type: 'success',
        });
      })
      .catch((e) => {
        toast.update(toastId, {
          render: e.message,
          type: 'error',
        });
      });
  }

  return (
    <>
      <ProjectForm
        handleSubmit={handleEdit}
        initialData={extractInitialData({
          ...project,
          inspections,
          client,
        })}
        hideStartDate={inspections.length > 0}
        showInspectionCertTimeline={showInspectionCertTimeline}
        setShowInspectionCertTimeline={setShowInspectionCertTimeline}
        pdfEditingStatus={pdfEditingStatus}
        setPdfEditingStatus={setPdfEditingStatus}
      />
    </>
  );
};

export default ProjectSettings;
